import { useQuery } from '@tanstack/react-query';
import dailySiteReportService from '@services/dailySiteReport';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const MY_DAILY_SITE_REPORTS_QUERY_KEY = 'myDailySiteReports';

export const useMyDailySiteReports = (limit = 30, offset = 0) => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [MY_DAILY_SITE_REPORTS_QUERY_KEY, organizationId, limit, offset],
    queryFn: () => dailySiteReportService.getMyDailySiteReports(limit, offset),
    enabled: !!organizationId,
  });
};

export default useMyDailySiteReports;
